import React, { useContext, useEffect, useState } from "react";
import DemoData from "../../data/DemoData";
import CandidateItem from "./CandidateItem";
import Dropdown from "react-bootstrap/Dropdown";
import { AuthContext } from "../../context/AuthContext";
import ENDPOINT from "../../context/EndPoint";
import axios from "axios";
import { Link } from "react-router-dom";
import PlacementRecommendationItem from "./PlacementRecommendationItem";
import { useDispatch } from "react-redux";
import { useActionsContext } from "../../context/ActionsContext";

const StudentsRankings = () => {
  const { user } = useContext(AuthContext);
  const [internships, setinternships] = useState(null);
  const [applications, setApplications] = useState(null);
  const dispatch = useDispatch()
  const { rowsPerPage, setRowsPerPage } = useActionsContext(); 
  

  const GetInternships = async (status) => {
    dispatch({ type: 'LOADING' });
  
    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append('limit', rowsPerPage);
    formData.append("status", status || "all"); // Use parameter if provided, default to "all"
  
    try {
      const res = await axios.post(
        ENDPOINT + "student-placement-ranks.php",
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );
  
      if (res) {
        if (res.data.status === "success") {
          dispatch({ type: 'DONE_LOADING' });
          setinternships(res.data.data);
          setApplications(res.data);
        } else {
          dispatch({ 
            type: 'ERROR', 
            payload: res.data.message || 'Failed to fetch internships' 
          });
        }
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while fetching internships' 
      });
    }
  };

  useEffect(() => {
    GetInternships();
  }, [rowsPerPage]);

  return (
    <>
      <div className="container-fluid">
        <div className="row gy-2 mb-2" id="candidate-list">
          {internships ? (
            <>
              <div class="dropdown topbar-head-dropdown ms-1 header-item bg-white">
                <button
                  type="button"
                  class="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="bx bx-category-alt fs-22"></i>
                </button>
                <div class="dropdown-menu w-75 p-0 dropdown-menu-start">
                  <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                    <div class="row align-items-center">
                      <div class="col">
                        <h6 class="m-0 fw-semibold fs-15"> Quick Actions </h6>
                      </div>
                      <div class="col-auto">
                        <Link to="#!" class="btn btn-sm btn-soft-info">
                          {" "}
                          View All
                          <i class="ri-arrow-right-s-line align-middle"></i>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div class="p-2 w-100 vh-75 overflow-y">
                    <form action="">
                      <div class="row g-0 ">
                        <div className="col-lg-4">
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Technical Proficiency
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              AI Awareness
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Problem Solving
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Soft Skills
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Adaptability
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Continuous Learning
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Innovation
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Data Literacy
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Networking
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Personal Branding
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Cultural Awareness
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Role Specific Skills
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Resilience
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Communication
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Collaboration
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Creativity
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Work Ethic
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Leadership
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Entrepreneurship
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">Agility</label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Global Awareness
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">Ethics</label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Time Management
                            </label>
                          </div>

                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Productivity
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Mentorship
                            </label>
                          </div>

                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Decision Making
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Attention to Detail
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Emotional Intelligence
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Self Motivation
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Accountability
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Interpersonal Skills
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Feedback Reception
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Stress Management
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Self Discipline
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Public Speaking
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Innovation Thinking
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Project Management
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Technical Adaptability
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Workplace Maturity
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Conflict Resolution
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Goal Orientation
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Research Skills
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Customer Focus
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">Teamwork</label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Multitasking
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">Vision</label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Persistence
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Self Improvement
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Business Acumen
                            </label>
                          </div>
                          <div className="form-check pb-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                            />
                            <label className="form-check-label">
                              Attendance
                            </label>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {internships.map((item) => (
                <>
                  <div className="col-md-6 col-lg-12">
                    <PlacementRecommendationItem item={item} />
                  </div>
                </>
              ))}
            </>
          ) : (
            <></>
          )}
        </div>
        {/* end row */}
        <div
          className="row g-0 justify-content-end mb-4"
          id="pagination-element"
        >
          {/* end col */}
          <div className="col-sm-6">
            <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
              <div className="page-item disabled">
                <a
                  href="javascript:void(0);"
                  className="page-link"
                  id="page-prev"
                >
                  Previous
                </a>
              </div>
              <span id="page-num" className="pagination">
                <div className="page-item active">
                  <a
                    className="page-link clickPageNumber"
                    href="javascript:void(0);"
                  >
                    1
                  </a>
                </div>
                <div className="page-item">
                  <a
                    className="page-link clickPageNumber"
                    href="javascript:void(0);"
                  >
                    2
                  </a>
                </div>
                <div className="page-item">
                  <a
                    className="page-link clickPageNumber"
                    href="javascript:void(0);"
                  >
                    3
                  </a>
                </div>
              </span>
              <div className="page-item">
                <a
                  href="javascript:void(0);"
                  className="page-link"
                  id="page-next"
                >
                  Next
                </a>
              </div>
            </div>
          </div>
          {/* end col */}
        </div>
        {/* end row */}
      </div>
    </>
  );
};

export default StudentsRankings;
